import Link from 'next/link';

import { SOCAIL } from '@common/constants';
import { cx } from '@emotion/css';
import { Post } from '@lib/wordpress.d';
import { isElementInViewport } from '@modules/shared/isElementInViewport';
import Image from 'next/image';

import { extractIdFromHtml } from '../extractIdFromHtml';

type Props = {
  styles: any;
  post: Post;
};

export const LeftMenu = (props: Props) => {
  const { styles, post } = props;
  const matches = extractIdFromHtml(post.content.rendered, 'menu-');
  // get the id of all the elements
  const ids = matches.map((match) => match.id);
  const inViewElements = isElementInViewport(ids);

  return (
    <div className={cx(styles.blog_details_left)}>
      <div className={styles.blog_details_inner}>
        <ul className={styles.blog_details_menu}>
          {matches.map((match, index: number) => (
            <MenuLink
              key={index}
              styles={styles}
              id={match.id}
              text={match.content}
              isVisible={inViewElements == match.id}
            />
          ))}
        </ul>
        <SocialMedia styles={styles} />
      </div>
    </div>
  );
};

const MenuLink = ({ styles, id, text, isVisible }: any) => {
  let linkStyle = styles.blog_details_link;

  if (isVisible) {
    linkStyle = cx(styles.blog_details_link, styles.blog_details_li_active);
  }

  return (
    <li className={cx(styles.blog_details_li)}>
      <a href={`#${id}`} className={linkStyle}>
        <span
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </a>
    </li>
  );
};

const SocialMedia = ({ styles }: any) => (
  <div className={styles.blog_details_social}>
    <ul className={styles.details_social}>
      <li className={styles.details_social_li}>
        <Link
          href={SOCAIL.TWITTER}
          target="_blank"
          className={styles.social_link}>
          <Image
            src="/images/blog/details/dark-twt.svg"
            alt="twitter icon"
            width={20}
            height={17}
          />
        </Link>
      </li>
      <li className={styles.details_social_li}>
        <Link
          href={SOCAIL.FACEBOOK}
          target="_blank"
          className={styles.social_link}>
          <Image
            src="/images/blog/details/dark-fb.svg"
            alt="facebook icon"
            width={22.4}
            height={22.4}
          />
        </Link>
      </li>
      <li className={styles.details_social_li}>
        <Link
          href={SOCAIL.LINKEDIN}
          target="_blank"
          className={styles.social_link}>
          <Image
            src="/images/blog/details/dark-linkd.svg"
            alt="linkedin icon"
            width={21}
            height={20}
          />
        </Link>
      </li>
      <li className={styles.details_social_li}>
        <Link
          href={SOCAIL.INSTAGRAM}
          target="_blank"
          className={styles.social_link}>
          <Image
            src="/images/blog/details/dark-insta.svg"
            alt="instagram icon"
            width={22.4}
            height={22.4}
          />
        </Link>
      </li>
    </ul>
  </div>
);
